import React from "react";
import { Card, Flex, Space, Dropdown } from "antd";
import ReactCountryFlag from "react-country-flag";
import GradientButton from "../UI/GradientButton";
import "./index.scss";

interface Country {
  countryCode: number;
  countryName: string;
  isoCode: string;
  iso3Code: string;
}

interface Addon {
  _id: string;
  addonName: string;
  addonCost: string;
  addonType: number;
  type: string;
  countries: Country[];
}

interface AddonCardProps {
  smsPhoneNumber?: any;
  addon: Addon;
  onSubscribe: any;
  loading?: boolean;
  isHighlighted?: boolean;
}

const AddonCard: React.FC<AddonCardProps> = ({
  addon,
  onSubscribe,
  loading,
  smsPhoneNumber,
  isHighlighted = false,
}) => {
  const getMenuitems = (countries: Country[]) => {
    return (
      countries?.slice(2).map((country: Country) => ({
        key: country.isoCode,
        label: (
          <Flex align="center" gap={10}>
            <ReactCountryFlag svg countryCode={country.isoCode} />
            {country.countryName}
          </Flex>
        ),
      })) || []
    );
  };

  return (
    <Card
      key={addon._id}
      className={`addon-card ${isHighlighted ? "highlighted-item" : ""}`}
      styles={{ body: { padding: 0, width: "100%", display: "flex" } }}
    >
      <Flex className="w-full" align="center" gap={10}>
        <Space direction="vertical" size={4}>
          <div className="flags-wrapper">
            <div className="flag">
              <ReactCountryFlag svg countryCode={addon.countries[0]?.isoCode} />
            </div>
            {addon.countries[1]?.isoCode && (
              <div className="flag-2">
                <ReactCountryFlag
                  svg
                  countryCode={addon.countries[1]?.isoCode}
                />
              </div>
            )}
          </div>
          {addon.countries.length > 2 && (
            <Dropdown
              overlayClassName="custom-dropdown"
              menu={{ items: getMenuitems(addon.countries) }}
            >
              <a
                className="countries-dropdown"
                onClick={(e) => e.preventDefault()}
              >
                +{addon.countries.length - 2} more
              </a>
            </Dropdown>
          )}
        </Space>

        <Space direction="vertical" align="start" size={0}>
          <div title={addon.addonName} className="addon-name">
            <h4>{addon.addonName}</h4>
          </div>
          <p>${addon.addonCost} Monthly</p>
        </Space>

        <GradientButton
          loading={loading}
          disabled={loading}
          onClick={() => onSubscribe(addon, smsPhoneNumber)}
          className="subscribe-btn"
        >
          Subscribe
        </GradientButton>
      </Flex>
    </Card>
  );
};

export default AddonCard;
